// ── FORMATAÇÃO ────────────────────────────────────────────────────────────────
export const formatCPF = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
};

export const formatPhone = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  return d.length <= 10
    ? d.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
    : d.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
};

export const limparTelefone = (tel) => (tel ? tel.replace(/\D/g, '') : '');

// ── VALIDAÇÃO ─────────────────────────────────────────────────────────────────
export const validateCPF = (cpf) => {
  const c = cpf.replace(/\D/g, '');
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  let sum = 0;
  for (let i = 1; i <= 9; i++) sum += parseInt(c[i - 1]) * (11 - i);
  let rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(c[9])) return false;
  sum = 0;
  for (let i = 1; i <= 10; i++) sum += parseInt(c[i - 1]) * (12 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  return rest === parseInt(c[10]);
};

export const validateAge = (dateStr) => {
  const birth = new Date(dateStr);
  const today = new Date();
  const age = today.getFullYear() - birth.getFullYear()
    - (today < new Date(today.getFullYear(), birth.getMonth(), birth.getDate()) ? 1 : 0);
  return age >= 18;
};

// ── LABELS E CORES ────────────────────────────────────────────────────────────
export const ROLE_LABEL = {
  ADMIN: '👑 Admin',
  COORDENADOR_GERAL: '🔵 Coord. Geral',
  COORDENADOR_MUNICIPAL: '🟢 Coord. Municipal',
  LIDERANCA: '🟡 Liderança',
  APOIADOR: '⚪ Apoiador',
};

export const ROLE_COLOR = {
  ADMIN: '#c0392b',
  COORDENADOR_GERAL: '#1a56db',
  COORDENADOR_MUNICIPAL: '#057a55',
  LIDERANCA: '#c27803',
  APOIADOR: '#6b7280',
};

export const SITUACAO_ELEIT_LABEL = {
  EM_ANALISE: '🔍 Em Análise',
  IRREGULAR:  '⚠️ Irregular',
  ATIVO:      '✅ Ativo',
};

export const SITUACAO_ELEIT_COLOR = {
  EM_ANALISE: '#c27803',
  IRREGULAR:  '#c0392b',
  ATIVO:      '#057a55',
};

export const VALIDACAO_WA_LABEL = {
  INATIVO:      '⬜ Inativo',
  ATIVO:        '✅ Validado',
  NAO_VALIDADO: '❌ Não Validado',
};

export const VALIDACAO_WA_COLOR = {
  INATIVO:      '#6b7280',
  ATIVO:        '#057a55',
  NAO_VALIDADO: '#cc0000',
};

// Funções de conveniência (mantidas para compatibilidade)
export const roleLabel        = (r) => ROLE_LABEL[r]            || r;
export const roleColor        = (r) => ROLE_COLOR[r]            || '#6b7280';
export const situacaoEleitLabel = (s) => SITUACAO_ELEIT_LABEL[s] || s;
export const situacaoEleitColor = (s) => SITUACAO_ELEIT_COLOR[s] || '#6b7280';
export const validacaoWALabel = (v) => VALIDACAO_WA_LABEL[v]   || '⬜ Inativo';
export const validacaoWAColor = (v) => VALIDACAO_WA_COLOR[v]   || '#6b7280';

// ── WHATSAPP ──────────────────────────────────────────────────────────────────
export const gerarMsgVerificacao = (nome, cpf) =>
  `Olá *${nome}*!\n\nSou do sistema *Politics System*.\n\nIdentificamos seu cadastro:\n\n👤 *Nome:* ${nome}\n🪪 *CPF:* ${cpf || 'não informado'}\n\nVocê confirma que é o titular deste cadastro?\n\nResponda:\n*1* - ✅ Sim, sou eu\n*0* - ❌ Não, não fui eu`;

// BFS — retorna todos os descendentes de um parentId a partir de uma lista plana
export const getSubtree = (users, parentId) => {
  const result  = [];
  const visited = new Set();
  const queue   = [String(parentId)];
  while (queue.length) {
    const current = queue.shift();
    if (visited.has(current)) continue;
    visited.add(current);
    users
      .filter(u => u.parent_id != null && String(u.parent_id) === current)
      .forEach(u => { result.push(u); queue.push(String(u.id)); });
  }
  return result;
};
